import BaseComponent from '../BaseComponent'
import PlayLogVideo from '../pages/PlayLogVideo'
import React from 'react'
import _ from 'lodash'
import { bindFunctions } from '../lib/componentUtils'
import database from 'firebase/database'
import { withRouter } from 'react-router'

export default withRouter(
	class PlayLogVideoContainer extends BaseComponent {
		constructor(props) {
			super()
			this.state = {
				loading: true,
				log: null,
				exercise: null,
				backTo: decodeURIComponent(props.match.params.backTo),
				backTitle: decodeURIComponent(props.match.params.backTitle)
			}

			this.logId = props.match.params.logId

			this.loadingNames = ['log', 'exercise']

			bindFunctions(['doneLoading', 'goDoExercise'], this)
		}

		goDoExercise() {
			this.props.history.push(`/do/${this.state.log.exercise}`)
		}

		componentDidMount() {
			// Load the log
			this.logRef = database().ref(`logs/${this.logId}`)
			this.logRef.on('value', logSnap => {
				const log = logSnap.val()
				this.setState({ log }).then(() => this.doneLoading('log'))

				// Load the exercise
				if (this.exerciseRef) {
					this.loadingNames.push('exercise')
					this.exerciseRef.off()
				}
				this.exerciseRef = database().ref(`exercises/${log.exercise}`)
				this.exerciseRef.on('value', exerciseSnap => {
					const exercise = exerciseSnap.val()
					this.setState({ exercise }).then(() => this.doneLoading('exercise'))
				})
			})
		}

		componentWillUnmount() {
			if (this.logRef) {
				this.logRef.off()
			}
			if (this.exerciseRef) {
				this.exerciseRef.off()
			}
		}

		doneLoading(name) {
			this.loadingNames = _.pull(this.loadingNames, name)
			if (0 === this.loadingNames.length) {
				this.setState({ loading: false })
			}
		}

		render() {
			const methods = { goDoExercise: this.goDoExercise }
			return <PlayLogVideo {...this.state} {...methods} />
		}
	}
)



// WEBPACK FOOTER //
// ./src/containers/PlayLogVideoContainer.js